/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';

import { RestaurantTaxRuleMapEntity } from '../model/restaurantTaxRuleMapEntity';
import { SmartDineResponseRestaurantTaxRuleMapEntity } from '../model/smartDineResponseRestaurantTaxRuleMapEntity';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class RestaurantTaxRuleMapRestControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createUserRestaurantTaxRuleMapMaps(body: RestaurantTaxRuleMapEntity, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantTaxRuleMapEntity>;
    public createUserRestaurantTaxRuleMapMaps(body: RestaurantTaxRuleMapEntity, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantTaxRuleMapEntity>>;
    public createUserRestaurantTaxRuleMapMaps(body: RestaurantTaxRuleMapEntity, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantTaxRuleMapEntity>>;
    public createUserRestaurantTaxRuleMapMaps(body: RestaurantTaxRuleMapEntity, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createUserRestaurantTaxRuleMapMaps.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseRestaurantTaxRuleMapEntity>('post',`${this.basePath}/api/admin/restauranttaxrulemaps`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantTaxRuleMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRestaurantTaxRuleMap(restaurantTaxRuleMapId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantTaxRuleMapEntity>;
    public deleteRestaurantTaxRuleMap(restaurantTaxRuleMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantTaxRuleMapEntity>>;
    public deleteRestaurantTaxRuleMap(restaurantTaxRuleMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantTaxRuleMapEntity>>;
    public deleteRestaurantTaxRuleMap(restaurantTaxRuleMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantTaxRuleMapId === null || restaurantTaxRuleMapId === undefined) {
            throw new Error('Required parameter restaurantTaxRuleMapId was null or undefined when calling deleteRestaurantTaxRuleMap.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseRestaurantTaxRuleMapEntity>('delete',`${this.basePath}/api/admin/restauranttaxrulemaps/${encodeURIComponent(String(restaurantTaxRuleMapId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantTaxRuleMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRestaurantTaxRuleMap(restaurantTaxRuleMapId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantTaxRuleMapEntity>;
    public getRestaurantTaxRuleMap(restaurantTaxRuleMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantTaxRuleMapEntity>>;
    public getRestaurantTaxRuleMap(restaurantTaxRuleMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantTaxRuleMapEntity>>;
    public getRestaurantTaxRuleMap(restaurantTaxRuleMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantTaxRuleMapId === null || restaurantTaxRuleMapId === undefined) {
            throw new Error('Required parameter restaurantTaxRuleMapId was null or undefined when calling getRestaurantTaxRuleMap.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseRestaurantTaxRuleMapEntity>('get',`${this.basePath}/api/admin/restauranttaxrulemaps/${encodeURIComponent(String(restaurantTaxRuleMapId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRestaurantTaxRuleMaps(restaurantId: string, restaurantBranchId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantTaxRuleMapEntity>;
    public getRestaurantTaxRuleMaps(restaurantId: string, restaurantBranchId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantTaxRuleMapEntity>>;
    public getRestaurantTaxRuleMaps(restaurantId: string, restaurantBranchId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantTaxRuleMapEntity>>;
    public getRestaurantTaxRuleMaps(restaurantId: string, restaurantBranchId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getRestaurantTaxRuleMaps.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseRestaurantTaxRuleMapEntity>('get',`${this.basePath}/api/admin/restauranttaxrulemaps`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param restaurantTaxRuleMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRestaurantTaxRuleMap(body: RestaurantTaxRuleMapEntity, restaurantTaxRuleMapId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantTaxRuleMapEntity>;
    public updateRestaurantTaxRuleMap(body: RestaurantTaxRuleMapEntity, restaurantTaxRuleMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantTaxRuleMapEntity>>;
    public updateRestaurantTaxRuleMap(body: RestaurantTaxRuleMapEntity, restaurantTaxRuleMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantTaxRuleMapEntity>>;
    public updateRestaurantTaxRuleMap(body: RestaurantTaxRuleMapEntity, restaurantTaxRuleMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateRestaurantTaxRuleMap.');
        }

        if (restaurantTaxRuleMapId === null || restaurantTaxRuleMapId === undefined) {
            throw new Error('Required parameter restaurantTaxRuleMapId was null or undefined when calling updateRestaurantTaxRuleMap.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseRestaurantTaxRuleMapEntity>('put',`${this.basePath}/api/admin/restauranttaxrulemaps/${encodeURIComponent(String(restaurantTaxRuleMapId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
